/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRequestAppointmentModalLoader_item$ref = any;
export type PdpSharedBlurbTradeRequestAppointment_item$ref = any;
export type PdpSharedBlurbTradeRequestAppointment_item = {
    readonly isArt: boolean | null;
    readonly isFurniture: boolean | null;
    readonly " $fragmentRefs": PdpRequestAppointmentModalLoader_item$ref;
    readonly " $refType": PdpSharedBlurbTradeRequestAppointment_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbTradeRequestAppointment_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFurniture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModalLoader_item",
      "args": null
    }
  ]
};
(node as any).hash = '5692f5dad52623989f3898687f0e2c5f';
export default node;
